export default __webpack_public_path__ + "static/media/final_interview.bc3a7b10.png";